import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IAttachment } from 'app/request-form/_models/attachment.interface';

@Component({
  selector: 'app-download-attachment',
  templateUrl: './download-attachment.component.html',
  styleUrls: ['./download-attachment.component.scss'],
  standalone: false,
})
export class DownloadAttachmentComponent {
  @Input() viewModel: IAttachment;
  @Input() displayType: 'small' | 'normal' = 'normal';
  @Output() clickItem = new EventEmitter<any>();

  /**
   * Method called when item is clicked
   */
  onClick(): void {
    this.clickItem.emit();
  }

  /**
   * Method to format bytes to other size types ('Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB')
   * @param bytes file size
   * @param decimals number of decimal places
   * @returns the file size formated (Example: 102.54 KB)
   */
  formatBytes(bytes, decimals = 2): string {
    if (!bytes) {
      return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
